import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Result, Button } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';

const AttendanceSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const type = searchParams.get('type') || 'checkin';
  const studentName = searchParams.get('studentName') || '학생';
  
  // 자동 리디렉션 타이머
  const [countdown, setCountdown] = useState(5);
  
  useEffect(() => {
    // 5초 후 자동으로 홈페이지로 이동
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    
    return () => clearInterval(timer);
  }, [navigate]);
  
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="w-full max-w-md">
        <Result
          status="success"
          icon={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
          title={`${type === 'checkin' ? '입실' : '퇴실'} 처리가 완료되었습니다`}
          subTitle={`${countdown}초 후 자동으로 이동합니다`}
          extra={[
            <Button 
              type="primary" 
              key="home"
              onClick={() => navigate('/')}
              className="bg-indigo-600 hover:bg-indigo-700"
            >
              홈으로 이동
            </Button>
          ]}
        />
        <div className="text-center mt-8">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            {type === 'checkin' ? '입실' : '퇴실'} 처리가 완료되었습니다
          </h2>
          <p className="text-gray-600 mb-6">
            {studentName}님의 {type === 'checkin' ? '입실' : '퇴실'}이 정상적으로 처리되었습니다.
          </p>
          <div className="space-y-4">
            <button
              onClick={() => navigate('/attendance-register')}
              className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600 transition-colors"
            >
              다시 출결 등록하기
            </button>
            <button
              onClick={() => navigate('/')}
              className="block w-full text-gray-600 hover:text-gray-800"
            >
              홈으로 돌아가기
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttendanceSuccess; 